import React from 'react';
import { noop } from 'lodash';

export interface IAction {
  toggleAlerts: any;
  deleteAlerts: any;
}

interface AlertContext {
  actions: IAction;
}

export default React.createContext<AlertContext>({
  actions: {
    toggleAlerts: noop,
    deleteAlerts: noop,
  },
});
